module.exports = "<div class=\"hint\">\n  عن اضافة ملف فديو يجب ان لا يتعدي ١٠٠ ميجا\n</div>\n"